import LegalLayout from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout
      eyebrow="Legal"
      title="Terms of Service"
      lastUpdated="December 2025"
      testid="page-terms"
    >
      <h2 className="font-display font-bold text-2xl tracking-tight">Acceptance of terms</h2>
      <p>
        By accessing or purchasing from <strong>the12lawsofdatingdynamics.com</strong> (the "Site"), you agree to these Terms of Service. If you do not agree, please do not use the Site.
      </p>

      <h2 className="font-display font-bold text-2xl tracking-tight">The product</h2>
      <p>
        The Site sells the paperback book <em>The 12 Laws of Dating Dynamics</em> by Manuel Santana, published by Penmier Publishing. The book is sold for personal, non-commercial use. You may not reproduce, distribute, or resell the book or its contents without written permission.
      </p>

      <h2 className="font-display font-bold text-2xl tracking-tight">Orders & payment</h2>
      <p>
        All prices are listed in U.S. dollars. Payment is processed securely by Stripe. We reserve the right to refuse or cancel any order for any reason (suspected fraud, payment failure, shipping restrictions, etc.) and to issue a full refund.
      </p>

      <h2 className="font-display font-bold text-2xl tracking-tight">Shipping</h2>
      <p>
        Shipping is calculated at checkout via live carrier rates and fulfilled worldwide. Delivery times are estimates, not guarantees. Risk of loss passes to the customer once the parcel is handed to the carrier.
      </p>

      <h2 className="font-display font-bold text-2xl tracking-tight">Refunds</h2>
      <p>
        See our <a href="/refund-policy" className="underline text-[#D92D20]">Refund Policy</a> for details on returns, replacements, and refund processing times.
      </p>

      <h2 className="font-display font-bold text-2xl tracking-tight">Intellectual property</h2>
      <p>
        All text, design, imagery, and content on the Site — including the book's contents — are the property of Manuel Santana and Penmier Publishing. All rights reserved.
      </p>

      <h2 className="font-display font-bold text-2xl tracking-tight">Disclaimer</h2>
      <p>
        The book and the Site provide commentary on relationship and dating dynamics for informational and entertainment purposes only. They do not constitute professional psychological, legal, or medical advice. Use of the content is at your own risk.
      </p>

      <h2 className="font-display font-bold text-2xl tracking-tight">Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, Manuel Santana, Penmier Publishing, and their affiliates shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Site or the book.
      </p>

      <h2 className="font-display font-bold text-2xl tracking-tight">Changes to terms</h2>
      <p>
        We may update these Terms from time to time. Continued use of the Site after changes constitutes acceptance of the revised Terms.
      </p>

      <h2 className="font-display font-bold text-2xl tracking-tight">Contact</h2>
      <p>
        Questions? Email <a href="mailto:orders@12lawsbook.com" className="underline text-[#D92D20]">orders@12lawsbook.com</a>.
      </p>
    </LegalLayout>
  );
}
